var module = angular.module('octopusApp.projects');

module.controller('ProjectIndexController', function ($scope, $location, $timeout, busy, octopusRepository){
    var isLoading = $scope.isLoading = busy.create();

    $scope.projectGroups = null;
    $scope.projects = {};
    $scope.pulses = {};
    $scope.view = { showEmptyGroups: false };
    $scope.projectCount = 0;
    $scope.projectsLoading = {};
    $scope.projectGroupsWaitingForProjectsToLoad = 0;
    var newProjectGroupId = $location.search().newProjectGroupId;

    isLoading.promise(octopusRepository.ProjectGroups.all().then(function (results) {
        $scope.projectGroups = results;
        _.each(results, function(pg) {
            $scope.projectGroupsWaitingForProjectsToLoad++;
            var groupLoading = $scope.projectsLoading[pg.Id] = busy.create();
            groupLoading.promise(octopusRepository.Projects.listByGroup(pg).then(function(projects) {
                $scope.projects[pg.Id] = projects;
                $scope.projectCount = $scope.projectCount + projects.TotalResults;
                $scope.projectGroupsWaitingForProjectsToLoad--;
            }));
        });
    }));

    var hasProjects = function(projectGroup) {
        var projects = $scope.projects[projectGroup.Id];
        return projects && projects.Items.length > 0;
    };

    $scope.isGroupVisible = function(projectGroup) {
        return $scope.view.showEmptyGroups || hasProjects(projectGroup) || (newProjectGroupId && projectGroup.Id === newProjectGroupId);
    };

    $scope.anyShowing = function() {
        return _.find($scope.projectGroups, $scope.isGroupVisible);
    };

    $scope.anyHiding = function() {
        return _.find($scope.projectGroups, function(g) { return !$scope.isGroupVisible(g); });
    };

    $scope.anyLoading = function () {
        return $scope.isLoading.busy ||
          _.find(_.values($scope.projectsLoading), function(gl) { return gl.busy; });
    };
});










//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_index_controller.js
// module id = 515
// module chunks = 1